import { API_V1 } from '../config'
import { apiFetch } from './api'

export interface FolderSubfolder {
  id: number
  name: string
  color: string
  icon: string
  document_count: number
  subfolder_count: number
}

export interface Folder {
  id: number
  name: string
  parent: number | null
  color: string
  icon: string
  created_at: string
  document_count: number
  full_path: string
  subfolders: FolderSubfolder[]
  parent_info: { id: number; name: string; color: string } | null
  can_create_subfolder: boolean
  breadcrumbs: { id: number; name: string }[]
}

/** List folders for the given actor */
export async function listFolders(actorId?: string): Promise<Folder[]> {
  const params = new URLSearchParams()
  if (actorId) params.set('actor_id', actorId)

  const query = params.toString()
  const url = query ? `${API_V1}/documents/folders/?${query}` : `${API_V1}/documents/folders/`

  const response = await apiFetch(url)
  if (!response.ok) {
    throw new Error(`Failed to fetch folders: ${response.status}`)
  }
  return response.json()
}

/** Create a new folder */
export async function createFolder(
  name: string,
  parentId?: number,
  actorId?: string,
): Promise<Folder> {
  const params = new URLSearchParams()
  if (actorId) params.set('actor_id', actorId)

  const query = params.toString()
  const url = query ? `${API_V1}/documents/folders/?${query}` : `${API_V1}/documents/folders/`

  const body: Record<string, unknown> = { name }
  if (parentId != null) body.parent = parentId

  const response = await apiFetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
  })
  if (!response.ok) {
    const errorData = await response.json().catch(() => null)
    const message = errorData?.error || `Failed to create folder: ${response.status}`
    throw new Error(message)
  }
  return response.json()
}

/** Move documents to a folder (folderId=0 for unsorted) */
export async function moveToFolder(
  folderId: number,
  documentIds: string[],
  actorId?: string,
): Promise<{ moved: number }> {
  const body: Record<string, unknown> = { document_ids: documentIds }
  if (actorId) body.actor_id = actorId

  const response = await apiFetch(
    `${API_V1}/documents/folders/${folderId}/move-documents/`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  )
  if (!response.ok) {
    const errorData = await response.json().catch(() => null)
    const message = errorData?.error || `Failed to move documents: ${response.status}`
    throw new Error(message)
  }
  return response.json()
}
